/**
 *
 * @param {object} state
 * @param {object} action
 * @return {object}
 */
export default function reducer(state = {
}, action) {
  switch (action.type) {
    default:
      return state;
  }
}
